export default __webpack_public_path__ + "media/images/building_images/placeholder_2section-0797174ea1d930198e9f90a9ab86b99d.png";